(function () {
  'use strict';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = (window.Valme && Valme.routes && Valme.routes.root) || '/';
  const money = cents => {
    const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    return new Intl.NumberFormat(document.documentElement.lang || 'es-ES', { style: 'currency', currency: cur }).format(cents / 100);
  };

  requestAnimationFrame(() => document.body.classList.add('loaded'));

  /* ---------- Navegación ---------- */
  const nav = document.getElementById('nav');
  const onScrollNav = () => nav && nav.classList.toggle('scrolled', scrollY > 30);
  onScrollNav();

  const burger = document.getElementById('burger');
  const setMenu = open => {
    document.body.classList.toggle('menu-open', open);
    if (burger) {
      burger.setAttribute('aria-expanded', open);
      burger.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
    }
    document.body.style.overflow = open ? 'hidden' : '';
  };
  if (burger) burger.addEventListener('click', () => setMenu(!document.body.classList.contains('menu-open')));
  document.querySelectorAll('#mobileMenu a').forEach(a => a.addEventListener('click', () => setMenu(false)));

  /* ---------- Reveal ---------- */
  const initReveal = scope => {
    const els = (scope || document).querySelectorAll('.rv:not(.in), .rv-el:not(.in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(e => e.classList.add('in')); return; }
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
    els.forEach(el => io.observe(el));
  };

  /* ---------- Contadores ---------- */
  const initCounters = scope => {
    const cio = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (!e.isIntersecting) return;
        const el = e.target, end = parseFloat(el.dataset.count) || 0;
        cio.unobserve(el);
        if (reduce) { el.textContent = end; return; }
        const dur = 1600, t0 = performance.now();
        const step = t => {
          const p = Math.min((t - t0) / dur, 1);
          el.textContent = Math.round(end * (1 - Math.pow(1 - p, 4)));
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      });
    }, { threshold: 0.6 });
    (scope || document).querySelectorAll('[data-count]').forEach(el => cio.observe(el));
  };

  /* ---------- Parallax ---------- */
  let px = [];
  const collectParallax = () => { px = [...document.querySelectorAll('[data-parallax]')]; };
  const runParallax = () => {
    if (reduce) return;
    const vh = innerHeight;
    px.forEach(el => {
      const r = el.parentElement.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      const center = r.top + r.height / 2 - vh / 2;
      el.style.transform = `translate3d(0, ${(-center * parseFloat(el.dataset.parallax)).toFixed(1)}px, 0)`;
    });
  };

  /* ---------- Barra de compra móvil ---------- */
  const sticky = document.getElementById('stickyBuy');
  const runSticky = () => {
    if (!sticky) return;
    const hero = document.querySelector('.hero');
    const buy = document.querySelector('[data-buy-section]');
    const pastHero = hero ? hero.getBoundingClientRect().bottom < 0 : scrollY > 500;
    let onBuy = false;
    if (buy) { const b = buy.getBoundingClientRect(); onBuy = b.top < innerHeight && b.bottom > 0; }
    sticky.classList.toggle('show', pastHero && !onBuy && !document.body.classList.contains('drawer-open'));
  };

  let ticking = false;
  addEventListener('scroll', () => {
    if (ticking) return; ticking = true;
    requestAnimationFrame(() => { onScrollNav(); runParallax(); runSticky(); ticking = false; });
  }, { passive: true });
  addEventListener('resize', runParallax);

  /* ---------- Selector de colores LED ---------- */
  const initColors = scope => {
    (scope || document).querySelectorAll('[data-led-section]').forEach(sec => {
      if (sec.dataset.ready) return; sec.dataset.ready = '1';
      const swatches = [...sec.querySelectorAll('.swatch')];
      const imgs = [...sec.querySelectorAll('.stage-imgs img')];
      const stage = sec.querySelector('.stage-bg');
      const caption = sec.querySelector('.color-caption');
      if (!swatches.length) return;
      let current = null;
      const setColor = key => {
        if (key === current) return; current = key;
        swatches.forEach(s => s.classList.toggle('active', s.dataset.c === key));
        imgs.forEach(i => i.classList.toggle('on', i.dataset.c === key));
        const sw = swatches.find(s => s.dataset.c === key);
        if (!sw) return;
        if (stage) stage.style.setProperty('--led', sw.style.getPropertyValue('--c'));
        if (caption) caption.innerHTML = sw.querySelector('.swatch-name').innerHTML;
      };
      const start = swatches.find(s => s.classList.contains('active')) || swatches[swatches.length - 1];
      setColor(start.dataset.c);
      let userPicked = 0;
      swatches.forEach(s => s.querySelector('button').addEventListener('click', () => { userPicked = Date.now(); setColor(s.dataset.c); }));
      if (!matchMedia('(max-width:860px)').matches) {
        const sio = new IntersectionObserver(entries => {
          if (Date.now() - userPicked < 900) return;
          entries.forEach(e => { if (e.isIntersecting) setColor(e.target.dataset.c); });
        }, { rootMargin: '-56% 0px -42% 0px' });
        swatches.forEach(s => sio.observe(s));
      }
      const pre = new IntersectionObserver(es => {
        if (es[0].isIntersecting) { imgs.forEach(i => { i.loading = 'eager'; }); pre.disconnect(); }
      }, { rootMargin: '600px' });
      pre.observe(sec);
    });
  };

  /* ---------- FAQ: solo una abierta ---------- */
  const initFaq = scope => {
    (scope || document).querySelectorAll('.faq-list').forEach(list => {
      const qas = list.querySelectorAll('.qa');
      qas.forEach(d => d.addEventListener('toggle', () => { if (d.open) qas.forEach(o => { if (o !== d) o.open = false; }); }));
    });
  };

  /* ---------- Carrito (AJAX) ---------- */
  const drawer = document.getElementById('cartDrawer');
  const drawerBody = drawer && drawer.querySelector('.drawer-body');
  const drawerFoot = drawer && drawer.querySelector('.drawer-foot');
  const countEls = document.querySelectorAll('[data-cart-count]');
  let lastFocus = null;

  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  const updateCount = (n, bump) => countEls.forEach(el => {
    el.textContent = n;
    el.classList.toggle('has', n > 0);
    if (bump) { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
  });

  const renderCart = cart => {
    updateCount(cart.item_count);
    if (!drawer) return;
    if (!cart.item_count) {
      drawerBody.innerHTML = `<div class="drawer-empty"><p>Tu carrito está vacío.</p><a href="${root}#comprar" class="btn btn-primary" data-close-drawer>Ver el dispositivo</a></div>`;
      drawerFoot.hidden = true;
      return;
    }
    drawerFoot.hidden = false;
    drawerBody.innerHTML = cart.items.map((it, i) => {
      const img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x200$1$2') : '';
      const variant = it.variant_title && it.variant_title !== 'Default Title' ? `<div class="line-variant">${esc(it.variant_title)}</div>` : '';
      return `<div class="cart-line" data-line="${i + 1}">
        <img src="${img || (window.Valme && Valme.placeholder) || ''}" alt="${esc(it.product_title)}" width="84" height="84" loading="lazy">
        <div>
          <a class="line-title" href="${it.url}">${esc(it.product_title)}</a>${variant}
          <div class="qty" role="group" aria-label="Cantidad">
            <button type="button" data-qty="${it.quantity - 1}" aria-label="Quitar uno">−</button>
            <span aria-live="polite">${it.quantity}</span>
            <button type="button" data-qty="${it.quantity + 1}" aria-label="Añadir uno">+</button>
          </div>
          <div><button type="button" class="line-remove link-btn" data-qty="0">Eliminar</button></div>
        </div>
        <div class="line-price">${money(it.final_line_price)}</div>
      </div>`;
    }).join('');
    drawer.querySelector('[data-cart-total]').textContent = money(cart.total_price);
  };

  const fetchCart = () => fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());

  const openDrawer = () => {
    if (!drawer) { location.href = root + 'cart'; return; }
    lastFocus = document.activeElement;
    document.body.classList.add('drawer-open');
    document.body.style.overflow = 'hidden';
    drawer.setAttribute('aria-hidden', 'false');
    runSticky();
    setTimeout(() => { const c = drawer.querySelector('.drawer-close'); c && c.focus(); }, 50);
  };
  const closeDrawer = () => {
    document.body.classList.remove('drawer-open');
    document.body.style.overflow = '';
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
    if (lastFocus) lastFocus.focus();
    runSticky();
  };

  document.addEventListener('click', e => {
    const opener = e.target.closest('[data-open-cart]');
    if (opener && drawer) { e.preventDefault(); fetchCart().then(renderCart); openDrawer(); return; }
    if (e.target.closest('[data-close-drawer]') || e.target.classList.contains('drawer-overlay')) {
      const link = e.target.closest('a[href]');
      closeDrawer();
      if (link && link.getAttribute('href').indexOf('#') > -1 && location.pathname === root) return;
      return;
    }
    const q = e.target.closest('[data-qty]');
    if (q && drawer && drawer.contains(q)) {
      const line = q.closest('[data-line]').dataset.line;
      drawer.classList.add('drawer-loading');
      fetch(root + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: +line, quantity: Math.max(0, +q.dataset.qty) })
      }).then(r => r.json()).then(renderCart).finally(() => drawer.classList.remove('drawer-loading'));
    }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && document.body.classList.contains('drawer-open')) closeDrawer(); });

  /* ---------- Formularios de producto ---------- */
  const initProductForms = scope => {
    (scope || document).querySelectorAll('form[data-product-form]').forEach(form => {
      if (form.dataset.ready) return; form.dataset.ready = '1';
      const err = form.querySelector('.form-error');
      const idInput = form.querySelector('input[name="id"]');
      const addBtn = form.querySelector('[data-add]');
      const buyBtn = form.querySelector('[data-buy-now]');
      const variantsEl = form.querySelector('script[data-variants]');
      const variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
      const qtyInput = form.querySelector('input[name="quantity"]');

      form.querySelectorAll('[data-step]').forEach(b => b.addEventListener('click', () => {
        const v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.dataset.step, 10));
        qtyInput.value = v;
      }));

      const syncVariant = () => {
        if (!variants.length) return;
        const chosen = [...form.querySelectorAll('.variant-picker fieldset')].map(fs => {
          const c = fs.querySelector('input:checked'); return c ? c.value : null;
        });
        const v = variants.find(v => v.options.every((o, i) => o === chosen[i]));
        const priceEl = form.closest('[data-buy-section]') && form.closest('[data-buy-section]').querySelector('[data-price]');
        if (!v) { addBtn && (addBtn.disabled = true); buyBtn && (buyBtn.disabled = true); return; }
        idInput.value = v.id;
        const ok = v.available;
        [addBtn, buyBtn].forEach(b => { if (b) { b.disabled = !ok; } });
        if (addBtn) addBtn.querySelector('[data-label]').textContent = ok ? addBtn.dataset.labelOk : 'Agotado';
        if (priceEl) priceEl.textContent = money(v.price);
        const url = new URL(location.href);
        if (form.dataset.updateUrl === 'true') { url.searchParams.set('variant', v.id); history.replaceState({}, '', url); }
      };
      form.querySelectorAll('.variant-picker input').forEach(i => i.addEventListener('change', syncVariant));

      const add = () => {
        if (err) err.hidden = true;
        const fd = new FormData(form);
        return fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
          .then(r => r.json().then(j => { if (!r.ok) throw j; return j; }));
      };

      form.addEventListener('submit', e => {
        e.preventDefault();
        const btn = e.submitter && e.submitter.hasAttribute('data-buy-now') ? buyBtn : addBtn;
        if (!btn) return;
        btn.setAttribute('aria-busy', 'true'); btn.disabled = true;
        add().then(() => {
          if (btn === buyBtn) { location.href = root + 'checkout'; return; }
          return fetchCart().then(cart => { renderCart(cart); updateCount(cart.item_count, true); openDrawer(); });
        }).catch(j => {
          if (err) { err.textContent = (j && (j.description || j.message)) || 'No se ha podido añadir al carrito. Inténtalo de nuevo.'; err.hidden = false; }
        }).finally(() => { btn.removeAttribute('aria-busy'); btn.disabled = false; });
      });
    });
  };

  /* Botones "Comprar" sueltos (barra móvil, cierre): añaden y van al checkout */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-quick-buy]');
    if (!b) return;
    const id = b.dataset.variantId;
    if (!id) return;
    e.preventDefault();
    b.setAttribute('aria-busy', 'true');
    fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] })
    }).then(r => { if (!r.ok) throw r; location.href = root + 'checkout'; })
      .catch(() => { location.href = b.getAttribute('href'); })
      .finally(() => b.removeAttribute('aria-busy'));
  });

  /* Galería del bloque de compra */
  const initThumbs = scope => {
    (scope || document).querySelectorAll('[data-buy-media]').forEach(m => {
      const main = m.querySelector('[data-main-img]');
      m.querySelectorAll('[data-thumb]').forEach(t => t.addEventListener('click', () => {
        m.querySelectorAll('[data-thumb]').forEach(o => o.classList.toggle('on', o === t));
        main.style.opacity = 0;
        const src = t.dataset.src, srcset = t.dataset.srcset;
        setTimeout(() => { main.src = src; if (srcset) main.srcset = srcset; main.style.opacity = 1; }, 180);
      }));
    });
  };

  /* ---------- Init + editor de temas ---------- */
  const init = scope => {
    initReveal(scope); initCounters(scope); collectParallax(); runParallax();
    initColors(scope); initFaq(scope); initProductForms(scope); initThumbs(scope); runSticky();
  };
  init();
  document.querySelectorAll('[data-year]').forEach(el => { el.textContent = new Date().getFullYear(); });

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', e => init(e.target));
    document.addEventListener('shopify:block:select', e => {
      const sw = e.target.closest('.swatch');
      if (sw) sw.querySelector('button').click();
      const qa = e.target.closest('.qa');
      if (qa) qa.open = true;
    });
  }
})();
